//============================
//# rssysisyncfeature
//# Interfész szinkron interfész - interfész típus reláció (láthatóság és funkciók)
//============================

/** Interfész funkciók — az értékek az IfaceSyncFeature mezőnevei */
export enum IfaceFeature {
    /** Kijelölt tételek szinkronizálása */
    DsyncSelectItems = "dsyncSelectItems",
    /** Interfész szinkronizálása a megadott intervallumra */
    DsyncInterface = "dsyncInterface",
    /** Lekérdezés indítása az interfészre */
    DsyncSendRequest = "dsyncSendRequest",
    /** Beolvasás fájlból */
    DsyncFromFile = "dsyncFromFile",
}

export default interface IfaceSyncFeature {
    id: number;
    /** Interfész (cssysisynciface) */
    interface: number;
    /** Interfész típusa (cssysisyncifacetyp) */
    interfaceType: number;
    /** Látható-e az interfész típus ezen az interfészen */
    visible: boolean;
    /** Kijelölt tételek szinkronizálása engedélyezett */
    dsyncSelectItems: boolean;
    /** Interfész szinkronizálása a megadott intervallumra engedélyezett */
    dsyncInterface: boolean;
    /** Lekérdezés indítása az interfészre engedélyezett */
    dsyncSendRequest: boolean;
    /** Beolvasás fájlból engedélyezett */
    dsyncFromFile: boolean;
}

export const IfaceSyncFeatureDefaultProps: IfaceSyncFeature = {
    id: 1,
    interface: 1,
    interfaceType: 1,
    visible: false,
    dsyncSelectItems: false,
    dsyncInterface: false,
    dsyncSendRequest: false,
    dsyncFromFile: false,
}
